// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Ojmt","tab":"Tabs_tab__3rOl_","tabActive":"Tabs_tabActive__ayfW-"};